// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"51a12e4f","230":"ddd85cd9"}[chunkId] + ".chunk.js";
};